import React from "react";
import ContentLoader from "react-content-loader";
import { Card, CardBody } from "reactstrap";

export const CardSkeleton = ({}) => (
  <Card
    className="CardContent-Product"
    style={{
      borderRadius: "0px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    }}
  >
    <CardBody className="p-0">
      <ContentLoader viewBox="0 0 276 299">
        <rect x="0" y="0" rx="0" ry="0" width="276" height="180" />
        <rect x="3" y="210" rx="0" ry="0" width="260" height="20" />
        <rect x="3" y="240" rx="0" ry="0" width="239" height="20" />
      </ContentLoader>
    </CardBody>
  </Card>
);

export const SignificantWordCardSkeleton = (props) => (
  <ContentLoader viewBox="0 0 140 60" {...props}>
    <rect x="20" y="10" width="100" height="10" rx="3" />
    <rect x="40" y="30" width="60" height="5" rx="3" />
    <rect x="40" y="40" width="60" height="5" rx="3" />
    <rect x="40" y="50" width="60" height="5" rx="3" />
  </ContentLoader>
);
